import React from 'react';
import { Router, withTranslation } from '@i18n';
import { OPINION_MAIN_FLOW, TREATMENT_COST_FLOW } from '@routes';

import CampaignForm from '@components/PopupBanner/CampaignForm/index';
import {
  BannerContainer,
  StyledSubText,
  BannerContent,
  ImageContainer,
  ImageOverlay,
  ImageText,
  ContentContainer,
  TextContentHeading,
  TextContentSubHeading,
  FormContainer,
  RedirectContainer,
  RedirectButton,
  StyledDiv
} from './styles';

const Campaign = ({ campaign, t }) => {
  const [modalSlide, setModalSlide] = React.useState(0);
  const consturl = window.location.pathname;

  const handleRedirect = (pathname) => {
    if (pathname === 'secondOpinon') {
      Router.pushRoute(OPINION_MAIN_FLOW, { path: 'name' });
    } else {
      Router.pushRoute(TREATMENT_COST_FLOW, { path: 'name' });
    }
  };

  if (!campaign) return null;

  return (
    <>
      <BannerContainer>
        <BannerContent>
          <ImageContainer form={campaign.form_type}>
            <img
              src={campaign.cover_image.url}
              alt={campaign.cover_image_alt_tag}
            />
            <ImageOverlay />
            <ImageText>{campaign.offer_text}</ImageText>
          </ImageContainer>

          <ContentContainer form={campaign.form_type}>
            <StyledDiv>
              <TextContentHeading>
                {campaign.heading}
              </TextContentHeading>
              <TextContentSubHeading>
                {campaign.sub_heading}
              </TextContentSubHeading>
            </StyledDiv>
            {
              campaign.form_type === 'Sign up Form'
              && (
              <FormContainer>
                <CampaignForm
                  booking_category="second-opinion"
                  curefyDomain={false}
                  formName="FinderForm"
                  id="form"
                  modalSlide={modalSlide}
                  setModalSlide={setModalSlide}
                  campaignName={campaign.name}
                  currentUrl={consturl}
                />
              </FormContainer>
              )
            }
            <StyledDiv>
              {
              campaign.form_type === 'Second Opinion Form'
              && (
                <RedirectContainer>
                  <RedirectButton
                    onClick={() => handleRedirect('secondOpinion')}
                  >
                    {t('SecondOpinion')}
                  </RedirectButton>
                  <StyledSubText>
                    {t('SecondOpinionText')}
                  </StyledSubText>
                </RedirectContainer>
              )
            }

              {
              campaign.form_type === 'Treatment Cost Flow Form'
              && (
              <RedirectContainer>
                <RedirectButton
                  onClick={() => handleRedirect('TPF')}
                >
                  {t('TreatmentPlan')}
                </RedirectButton>
                <StyledSubText>
                  {t('TreatmentPlanText')}
                </StyledSubText>
              </RedirectContainer>
              )
            }
            </StyledDiv>
          </ContentContainer>
        </BannerContent>
      </BannerContainer>
    </>
  );
};


export default withTranslation('ContactPage')(Campaign);
